import { render } from "./OnboardingJourney.vue?vue&type=template&id=4b6120bf&scoped=true&lang=pug"
import script from "./OnboardingJourney.vue?vue&type=script&lang=js"
export * from "./OnboardingJourney.vue?vue&type=script&lang=js"

import "./OnboardingJourney.vue?vue&type=style&index=0&id=4b6120bf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6120bf"]])

export default __exports__